module.exports = __webpack_public_path__ + "static/media/bak.74048405.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/bak.gif
// module id = 495
// module chunks = 0